import React from 'react';
import { useEditor } from '@craftjs/core';
import { useTheme } from '../../contexts/ThemeContext';
import { Settings, Trash2, Copy, ArrowUp, ArrowDown } from 'lucide-react';

export const SettingsPanel = () => {
  const { isDark } = useTheme();
  const { selected, actions } = useEditor((state) => {
    const currentNodeId = state.events.selected.values().next().value;
    let selected;

    if (currentNodeId && state.nodes[currentNodeId]) {
      const node = state.nodes[currentNodeId];
      selected = {
        id: currentNodeId,
        name: node.data?.displayName || node.data?.name || 'Block',
        settings: node.related?.toolbar,
        isDeletable: node.data?.name !== 'Canvas'
      };
    }

    return { selected };
  });

  return (
    <div className={`w-72 border-l overflow-y-auto ${isDark ? 'border-zinc-800 bg-zinc-900/50' : 'border-gray-200 bg-gray-50'}`}>
      {selected ? (
        <div className="p-4">
          {/* Header */}
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <Settings className={`h-4 w-4 ${isDark ? 'text-zinc-400' : 'text-gray-500'}`} />
              <h3 className={`font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                {selected.name}
              </h3>
            </div>
            {selected.isDeletable && (
              <button
                onClick={() => actions.delete(selected.id)}
                className="p-1.5 rounded-lg text-red-400 hover:bg-red-500/20"
                title="Delete"
              >
                <Trash2 className="h-4 w-4" />
              </button>
            )}
          </div>

          {/* Settings */}
          {selected.settings && React.createElement(selected.settings)}
        </div>
      ) : (
        <div className="p-4 text-center">
          <Settings className={`h-8 w-8 mx-auto mb-2 ${isDark ? 'text-zinc-600' : 'text-gray-400'}`} />
          <p className={`text-sm ${isDark ? 'text-zinc-500' : 'text-gray-500'}`}>
            Select a block to edit its settings
          </p>
        </div>
      )}
    </div>
  );
};